import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Input, Modal, Radio, Row, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;
const Textarea = Input;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const { data, parentLevelCode } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.uuid = data ? data.uuid : '';
        values.parentLevelCode = parentLevelCode;
        values.levelCode = data ? data.levelCode : '';
        this.props.onOk(values);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={data && data.uuid ? '编辑菜单栏' : '创建菜单栏'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <Row>
            <Col span={20}>
              <FormItem label="所属系统" {...ItemLayout}>
                {getFieldDecorator('crappUuid', {
                  rules: [{ required: true, message: '所属系统!' }],
                  initialValue: data && data.uuid ? data.crappUuid : 'bszb',
                })(
                  <Select>
                    <Option value="core">系统平台</Option>
                    <Option value="bszb">帮实资本投资管理决策系统</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="功能项名称" {...ItemLayout}>
                {getFieldDecorator('funName', {
                  rules: [{ required: true, message: '请输入功能项名称!' }],
                  initialValue: data && data.uuid ? data.funName : '',
                })(<Input placeholder="功能项名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="状态" {...ItemLayout}>
                {getFieldDecorator('status', {
                  rules: [{ required: true, message: '请选择状态!' }],
                  initialValue: data && data.uuid ? data.status : 1,
                })(
                  <Radio.Group value={data && data.uuid ? data.status : 1}>
                    <Radio value={1}>启用</Radio>
                    <Radio value={0}>禁用</Radio>
                  </Radio.Group>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="功能项类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择功能项类型!' }],
                  initialValue: data && data.uuid ? data.type : 'N',
                })(
                  <Select>
                    <Option value="A">系统分类</Option>
                    <Option value="C">导航分类</Option>
                    <Option value="N">功能导航</Option>
                    <Option value="B">功能按钮</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="服务名称" {...ItemLayout}>
                {getFieldDecorator('resource', {
                  rules: [{ required: true, message: '请输入服务名称!' }],
                  initialValue: data && data.uuid ? data.resource : '',
                })(<Input placeholder="服务名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="加载目标" {...ItemLayout}>
                {getFieldDecorator('target', {
                  initialValue: data && data.uuid ? data.target : '',
                })(<Input placeholder="加载目标" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="图标资源" {...ItemLayout}>
                {getFieldDecorator('pic', {
                  initialValue: data && data.uuid ? data.pic : '',
                })(<Input placeholder="图标资源" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="备注" {...ItemLayout}>
                {getFieldDecorator('remark', {
                  initialValue: data && data.uuid ? data.remark : '',
                })(<Textarea placeholder="备注" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/function/ModalFunctionAdd.js